import { styled } from "@mui/material/styles";
import { Box, Stack, Typography } from "@mui/material";
import { fonts } from "../../../theme/theme";
import { CHART } from "./CustomChart.constants";

export const RootBox = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2, 3.5),
  margin: "16px auto 0",
  border: `1px solid ${theme.palette.text.primary}`,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
}));

export const HeaderStack = styled(Stack)(({ theme }) => ({
  flexDirection: "row",
  justifyContent: "space-between",
  marginBottom: theme.spacing(2),
}));

export const HeaderTypography = styled(Typography)(({ theme }) => ({
  fontFamily: fonts.quicksand,
  fontSize: "16px",
  fontWeight: 500,
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(3),
}));

export const ChartWrapper = styled(Box)({
  width: CHART.SIZE,
  height: CHART.SIZE,
  margin: "0 auto",
});

export const TotalScoreBox = styled(Typography)(({ theme }) => ({
  fontFamily: fonts.gotham,
  fontSize: "16px",
  fontWeight: 500,
  color: theme.palette.text.primary,
  marginTop: theme.spacing(3),
}));

export const TotalScoreValue = styled(Typography)(({ theme }) => ({
  fontFamily: fonts.gotham,
  fontSize: "18px",
  fontWeight: "bold",
  color: theme.palette.text.primary,
}));
